import TAGSORT,{taglist} from "../class/tagsort";
import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia("(min-width:900px)") ];

const itemTemplate =  `
  <ul class="rwd002-stock__list" :class="[ 'is-paged-' + paged ]">
    <li class="rwd002-stock__item" v-for="(article , ind) in pagedArticles">
      <a class="rwd002-stock__link" :href="article.href">
        <figure class="thumb">
          <img :src="article.thumb" :alt="article.title">
          <figcaption class="item_status" v-if="article.category.name">{{ article.category.name }}</figcaption>
        </figure>
        <p class="ttl">{{ article.title }}</p>
      </a>
    </li>
  </ul>
  `;

const relatedItemTemplate =  `
  <div class="connection-list is-related">
    <h3 class="connection-list__title" v-if="relatedArticles && relatedArticles.length > 0">関連商品</h3>
    <ul class="connection-list__inner rwd002-stock__list" v-if="relatedArticles && relatedArticles.length > 0">
      <li class="rwd002-stock__item" v-for="(article , ind) in relatedArticles">
        <a class="rwd002-stock__link" :href="article.href">
          <figure class="thumb">
            <img :src="article.thumb" :alt="article.title">
            <figcaption class="item_status" v-if="article.category.name">{{ article.category.name }}</figcaption>
          </figure>
          <p class="ttl">{{ article.title }}</p>
        </a>
      </li>
    </ul>
  </div>
  `;

const tagsList = `
  <div class="stock-tag__wrap">
    <ul id="tagListMain" class="stock-tag__main-list">
      <li class="stock-tag__main-item"><a href="/tool/" class="stock-tag__main-link">ALL</a></li>
    </ul>
    <ul id="tagListSub" class="stock-tag__sub-list">
    </ul>
  </div>
`;

class taglist_custom extends taglist {
  constructor( opt, parent ) {
    super( opt, parent );
  }
  insertContainer ( tag = `<taglist />`) {
    const container = d.querySelector( this.opt.container || '.rwd002-container');
    if( !container ) return false;
  }
}

class OPTIONS {
  constructor() {
    this.addHtml();
    this.bottomTtlClone();
    this.selectTags();
    this.detailSlide();
  }

  // 一覧カテ見出し追加
  addHtml() {
    const is_list = d.body.classList.contains('is--list');
    const contentMain = d.querySelector('.rwd002-main');
    const contentHeader = d.querySelector('.content_header');
    const relatedContainer = d.querySelector('.connection-list');
    
    if( is_list ){
      contentMain.insertAdjacentHTML('beforebegin', tagsList);
    } else {
      relatedContainer.insertAdjacentHTML('beforeend', tagsList);
    }
  }

  detailSlide() {
    const is_detail = d.body.classList.contains('is--detail');

    if (is_detail) {
      const mainSlideWrap = document.querySelector('.main_slide__wrap');
      const mainSlide = document.querySelector('.main_slide');
    
      if (mainSlideWrap && mainSlide) {
        // main_slideをクローンしてmain_slide__wrapの後に挿入
        const clonedSlide = mainSlide.cloneNode(true);
        mainSlideWrap.parentNode.insertBefore(clonedSlide, mainSlideWrap.nextSibling);
    
        // クローンした要素のクラスをthumb_slideに変更
        clonedSlide.classList.remove('main_slide');
        clonedSlide.classList.add('thumb_slide');
    
        // thumb_slideの初期化
        const thumbSlide = new Swiper(".thumb_slide", {
          speed: 400,
          slidesPerView: 5,
          mousewheel: false,
          breakpoints: {
            400: {
              slidesPerView: 10,
              spaceBetween: 7
            }
          }
        });
    
        // main_slideの初期化
        const mainSlideInstance = new Swiper(".main_slide", {
          loop: true,
          speed: 400,
          slidesPerView: 1,
          mousewheel: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          thumbs: {
            swiper: thumbSlide,
          }
        });
      }
    }
  }

  // 詳細タイトル売約ボタン上に複製
  bottomTtlClone() {
    const is_detail = d.body.classList.contains('is--detail');
    if( is_detail ){
      $('.rwd002-detail__head').clone().addClass('bottom_ttl').insertBefore('.last_btn');
    }
  }

  selectTags() {
    const tags = [
      ['工作用補助機器', 'インデックス・円テーブル', '定盤・イケール・ブロック', 'バイス・万力', 'チャック', 'マグネット機器', 'クランプ工具・回転センター', '旋盤周辺機器', '研削盤周辺機器', 'ワイヤー加工機用機器', 'その他工作用補助機器'],
      ['ツーリング・ツーリング周辺機器', 'BT・BBT30', 'BT・BBT40', 'BT・BBT50', 'NT', 'HSK他', 'ボーリングツール', 'コレットチャック', '旋盤・複合機用ホルダー', 'ツーリング周辺機器'],
      ['切削工具・研削工具・金型', 'エンドミル', 'ドリル', 'タップ・ダイス', 'その他穴あけ・面取り工具', 'バイト・バイトホルダー', 'チップ', 'フライスカッター・フェイスミル', '砥石・その他研削工具', '金型', '転造・ブローチ・歯切り工具', 'その他加工工具'],
      ['投影機・測定機器・検査機器', '投影機・顕微鏡', '測定機器', '試験機・検査器', 'その他特殊機器'],
      ['測定工具・ゲージ', '内径測定工具', '外径測定工具', '深さ・その他専用測定工具', 'ノギス・定規', 'ブロックゲージ・その他基準片', '測定補助機器', 'ダイヤルゲージ', 'リングゲージ・栓ゲージ・ネジゲージ', 'ハイトゲージ', 'その他ゲージ類'],
      ['油圧・空圧機器・モーター類', '油圧機器', '空圧機器', 'ポンプ', 'モーター'],
      ['昇降機器・運搬機器', 'フォークリフト', 'ハンドパレット・ハンドリフト', '台車・コンベア', 'ホイスト・チェーンブロック', '昇降台', 'その他移動機器'],
      ['電動工具・作業工具', '電動工具', '油圧工具', '作業工具', 'その他工具類'],
      ['キャビネット・工場周辺設備', 'キャビネット・棚類', 'スポットクーラー・ヒーター・ファン', '事務機器', 'その他周辺設備'],
      ['機械部品・各種装置', 'NC機用部品', '汎用機用部品', 'その他機械部品', '各種入力機器', 'その他特殊装置']
    ];

    const tagListMain = document.getElementById('tagListMain');
    const tagListSub = document.getElementById('tagListSub');

    // tagListMainへの追加
    for (const tagGroup of tags) {
      const mainItem = document.createElement('li');
      mainItem.classList.add('stock-tag__main-item');
      const mainLink = document.createElement('a');
      mainLink.href = `/tool/?mode=list&tag=${encodeURI(tagGroup[0])}`; // エンコードしてURLに設定
      mainLink.classList.add('stock-tag__main-link');
      mainLink.textContent = tagGroup[0];
      mainItem.appendChild(mainLink);
      tagListMain.appendChild(mainItem);
    }

    // URLの検索
    const urlParams = new URLSearchParams(window.location.search);
    const encodedTag = urlParams.get('tag');
    const decodedTag = decodeURI(encodedTag); // デコードしてタグを取得

    let found = false;
    for (const tagGroup of tags) {
      if (tagGroup.some(tag => decodedTag.includes(tag))) { // デコードしたタグと比較
        for (const subTag of tagGroup.slice(1)) {
          const subItem = document.createElement('li');
          const subLink = document.createElement('a');
          subLink.href = `/tool/?mode=list&tag=${encodeURI(subTag)}`; // エンコードしてURLに設定
          subLink.textContent = subTag;
          subLink.classList.add('stock-tag__sub-link'); // クラスを追加
          subItem.appendChild(subLink);
          tagListSub.appendChild(subItem);
        }
        found = true;
        break; // 見つかったらループを抜ける
      }
    }

    // すべて含まれていない場合
    if (!found) {
      for (const tagGroup of tags) {
        for (const subTag of tagGroup.slice(1)) {
          const subItem = document.createElement('li');
          const subLink = document.createElement('a');
          subLink.href = `/tool/?mode=list&tag=${encodeURI(subTag)}`; // エンコードしてURLに設定
          subLink.textContent = subTag;
          subLink.classList.add('stock-tag__sub-link'); // クラスを追加
          subItem.appendChild(subLink);
          tagListSub.appendChild(subItem);
        }
      }
    }

    // currentクラスの追加
    const mainLinks = document.querySelectorAll('.stock-tag__main-link');
    let matchFound = false; // 一致フラグ

    mainLinks.forEach(link => {
      if (decodedTag === link.textContent) {
        link.classList.add('current');
        matchFound = true;
      }
    });

    const subLinks = document.querySelectorAll('.stock-tag__sub-link');
    subLinks.forEach(link => {
      if (decodedTag === link.textContent) {
        link.classList.add('current');
        matchFound = true;
      }
    });

    if (found) {
      mainLinks.forEach(link => {
        tags.forEach(tagGroup => {
          if (tagGroup[0] === link.textContent) {
            tagGroup.slice(1).forEach(subTag => {
              if (decodedTag === subTag) {
                link.classList.add('current');
                matchFound = true;
              }
            });
          }
        });
      });
    }

    // 一致するものがなかった場合、最初の"ALL"リンクにcurrentクラスを追加
    if (!matchFound && mainLinks.length > 0) {
      mainLinks[0].classList.add('current');
    }

    if(!mq.matches){
      if (tagListSub.offsetHeight > 120) {
        const slideBtn = document.createElement('button');
        slideBtn.id = 'slideBtn';
        slideBtn.className = 'stock-tag__slide-btn';
        slideBtn.textContent = 'すべてを表示';
    
        tagListSub.parentNode.insertBefore(slideBtn, tagListSub.nextSibling);
    
        slideBtn.addEventListener('click', () => {
          tagListSub.classList.toggle('open');
          slideBtn.classList.toggle('open');
          slideBtn.textContent = slideBtn.classList.contains('open') ? '閉じる' : 'すべてを表示';
        });
      }
    }
  }
}

const domReady = () => {
  
  const Tagsort = new TAGSORT({
    list: {
      itemTemplate,
      perpage: 12, // 一度に表示する記事数
    },
    related: {
      container: '.rwd002-pagination',
      itemTemplate: relatedItemTemplate
    }
  });

  d.addEventListener('tagsort.beforeInit', e => {
    const TAGSORT = e.detail;
    Tagsort.taglist = new taglist_custom( TAGSORT.opt.taglist, TAGSORT );
  });

  d.addEventListener('tagsort.afterRender', e => {
    const searchParams = new URLSearchParams( location.search );
    let queryEntries = searchParams.entries();
    let queryParamsObject = Object.fromEntries(queryEntries);
    new OPTIONS(queryParamsObject, e.detail.categories);
  });

  // Tagsort.init.then( tagsort => {  })

  Tagsort.render();
};

export default function MACHINERY () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );

  setTimeout(function(){
    const itemStatuses = document.querySelectorAll('.item_status');
    itemStatuses.forEach(item => {
      const text = item.textContent;
    
      if (text.includes('在庫有')) {
        item.classList.add('is-available');
      } else if (text.includes('商談中')) {
        item.classList.add('is-keep');
      } else if (text.includes('売却済')) {
        item.classList.add('is-unavailable');
      }
    });
  },1000);
}